import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2CheckmarkIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 55.149 47.512",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 55.149),
    children: /*#__PURE__*/jsx("path", {
      d: "M18.705 44.225L3.152 28.669a6.943 6.943 0 019.811-9.818l9.893 9.893L41.387 4.039a6.945 6.945 0 0111.115 8.329L29.171 43.481a6.945 6.945 0 01-10.466.744z"
    })
  });
};

export { PM2CheckmarkIcon };
//# sourceMappingURL=checkmark.js.map
